export const navigation = {
  chat: "Chat",
  newChat: "Novo Chat",
  chatHistory: "Histórico de Chat",
  login: "Entrar",
  settings: "Configurações",
};
